import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';

export const attachSitesToRoleCompaniesDriverObj = (dispatch, navigate) => {
  const driverObj = driver({
    allowClose: false,
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.siteCheckbox',
        popover: {
          title: 'Select Sites',
          description:
            'Use these checkboxes to select the sites you want to attach to the selected role company. You can choose multiple sites from the list.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.attachSites',
        popover: {
          title: 'Attach Selected Sites',
          description: 'Click this button to attach the selected sites to the chosen role company.',
          side: 'top',
          align: 'end',
          onNextClick: () => {
            navigate('/permissions_roles');
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default attachSitesToRoleCompaniesDriverObj;
